import { svg } from "lit";
const icon = svg `<path d="M10.0001 13.4855L5.28857 8.77402L6.0626 8L10.0001 11.9375L13.9376 8L14.7116 8.77402L10.0001 13.4855Z" fill="currentColor"/>`;
export default icon;
